<template>
  <div class="bg-image">
    <product-top-bar style="position: absolute; top: 0"/>
    <div class="form card">
      <div class="title">
        {{ $t('more_info_question') }}
      </div>
      <div>
        <label>
          {{ $t('name') }}<b class="primary"> * </b>
        </label>
        <input class="input" type="text" v-model="object.name" />
      </div>
      <div>
        <label>
          {{ $t('email') }}<b class="primary"> * </b>
        </label>
        <input class="input" type="text" v-model="object.email" />
      </div>
      <div>
        <label>
          {{ $t('phone') }}
        </label>
        <input class="input" type="text" v-model="object.phone" />
      </div>
      <div>
        <label>
          {{ $t('company') }}<b class="primary"> * </b>
        </label>
        <input class="input" type="text" v-model="object.company" />
      </div>
      <div>
        <label>
          {{ $t('remarks') }}
        </label>
        <textarea class="input" v-model="object.comments" />
      </div>
      <p style="padding: 1em 0">
        <input type="checkbox" style="width:auto" v-model="termsConditions"/>
        <i18n tag="span" style="white-space: initial" path="accept_terms_conditions">
          <router-link to="/terms-conditions">
            {{ $t('terms_conditions') }}
          </router-link>
          <router-link to="/privacy-policy">
            {{ $t('privacy_policy') }}
          </router-link>
        </i18n>
      </p>
      <div style="text-align: center">
        <button @click="prepareContact()" class="btn-blue">
          {{ $t('send') }}
        </button>
        <router-link to="/">
          <button  class="btn-black">
            {{ $t('back') }}
          </button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import ProductTopBar from '@/components/product/ProductTopBar'
export default {
  name: 'contact',
  components: { ProductTopBar },
  data () {
    return {
      object: {},
      termsConditions: false
    }
  },
  methods: {
    ...mapActions({
      contact: 'contact'
    }),
    sendEmail () {
      this.object.product = 'fim'
      this.object.language = this.$i18n.locale
      this.contact(this.object).then(() => {
        this.$notify({ group: 'global', duration: 4000, title: 'Success', type: 'success', text: this.$t('request_success') })
        this.object = {}
      })
    },
    prepareContact () {
      if (!this.termsConditions) {
        this.$notify({ group: 'global', duration: 4000, title: 'ERROR', type: 'error', text: this.$t('please_accept_terms') })
        return
      }
      if (!this.object.name || !this.object.email || !this.object.company) {
        if (!this.object.name) this.$notify({ group: 'global', duration: 4000, title: 'ERROR', type: 'error', text: this.$t('empty', { field: this.$t('name') }) })
        if (!this.object.email) this.$notify({ group: 'global', duration: 4000, title: 'ERROR', type: 'error', text: this.$t('empty', { field: this.$t('email') }) })
        if (!this.object.company) this.$notify({ group: 'global', duration: 4000, title: 'ERROR', type: 'error', text: this.$t('empty', { field: this.$t('company') }) })
        return
      }
      this.sendEmail()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
  .form {
    display: flex;
    flex-direction: column;
    max-width: 100vw;
    width: 30em;
    box-sizing: border-box;
    .title {
      font-size: 1.3em;
      color: $k-lime-text;
      white-space: initial;
      text-align: center;
    }
    label {
      display: block;
    }
    input, textarea {
      width: 100%;
    }
  }
  .bg-image {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background-image: url('/static/img/infobanner.jpg');
  }
  .card {
    padding: 1em 2em;
    background: rgba($color: white, $alpha: .9);
    border-radius: .2em;
  }
  .primary {
    color: $k-turq;
  }
  .title {
    text-transform: uppercase;
  }
  textarea {
    resize: vertical;
    min-height: 4em;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PageContact.vue